// extracted by mini-css-extract-plugin
export default {"verticalLayout":"zO2yh__verticalLayout"};